import { SerializedFiltersParams } from '@main/helpers/entity.helpers.types';

export const defaultPredefinedFilter = compPref(90, 'ALL-ALL', 'us');

/**
 * Compile filter preferences
 */
function compPref(period: string | number, channel: string, country: string): SerializedFiltersParams {
    return {
        period,
        channel,
        country,
    };
}
